module.exports = __webpack_public_path__ + "img/edge_activites_parcours_orientation.e73ef1af.svg";